import { styled } from '@mui/system';

export const Wrapper = styled('div')`
  display: block;
  text-align: center;
`;
